var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "headingsWrapper" }, [
    _vm.quizData.title && _vm.quizData.title !== ""
      ? _c("h2", [_vm._v("\n        " + _vm._s(_vm.quizData.title) + "\n    ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.quizData.subTitle && _vm.quizData.subTitle !== ""
      ? _c("h4", [
          _vm._v("\n        " + _vm._s(_vm.quizData.subTitle) + "\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }